import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, BehaviorSubject, throwError } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import { ToastrService } from 'ngx-toastr'

import { Checklist } from './checklist.model'
import { AppConfig } from 'src/app/app.config'
import { ErrorHandlerService } from 'src/app/common/error-handler.service'

@Injectable({
  providedIn: 'root',
})
export class ChecklistsService {
  checklistFormUpdated$: BehaviorSubject<boolean> = new BehaviorSubject(false)
  checklistUpdatesCanceled$: BehaviorSubject<boolean> = new BehaviorSubject(false)

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private toastr: ToastrService,
    private errorHandlerService: ErrorHandlerService,
  ) {}

  getChecklists(): Observable<Checklist[]> {
    const url: string = `${this.appConfig.config.server_api.checklists.all}`
    return this.http.get(url).pipe(map((response: any[]) => response.map((item) => new Checklist(item))))
  }

  getChecklist(checklistId: number): Observable<Checklist> {
    const url: string = `${this.appConfig.config.server_api.checklists.get}${checklistId}/`
    return this.http.get(url).pipe(map((response) => new Checklist(response)))
  }

  addChecklist(checklist: Checklist): Observable<object> {
    const url: string = this.appConfig.config.server_api.checklists.add
    const data = {
      name: checklist.name,
      instructions: checklist.instructions,
      checklist_type: checklist.checklist_type,
    }
    return this.http.post(url, data).pipe(
      map((response) => {
        const message: string = `Checklist ${checklist.name} successfully added`
        console.log(message)
        this.toastr.success(message, null, null)
        return response
      }),
      catchError((error) => {
        const message = `Can't add profile`
        this.errorHandlerService.showErrorMessage(error, message)
        return throwError(error)
      }),
    )
  }

  editChecklist(checklist: Checklist): Observable<object> {
    const url: string = `${this.appConfig.config.server_api.checklists.edit}${checklist.id}/`
    const data = {
      id: checklist.id,
      name: checklist.name,
      instructions: checklist.instructions,
      checklist_type: checklist.checklist_type,
    }

    return this.http.patch(url, data).pipe(
      map((response) => {
        const message: string = `Checklist successfully edited`
        console.log(message)
        this.toastr.success(message)
        return response
      }),
      catchError((error) => {
        const message = `Can't edit profile ${checklist.name}`
        this.errorHandlerService.showErrorMessage(error, message)
        return throwError(error)
      }),
    )
  }

  removeChecklist(checklist: Checklist): Observable<object> {
    const url: string = `${this.appConfig.config.server_api.checklists.delete}${checklist.id}/`

    return this.http.delete(url).pipe(
      map((response) => {
        const message: string = `Checklist ${checklist.name} removed successfully`
        console.log(message)
        this.toastr.success(message)
        return response
      }),
      catchError((error) => {
        const message = `Can't remove profile ${checklist.name}`
        this.errorHandlerService.showErrorMessage(error, message)
        return throwError(error)
      }),
    )
  }
}
